module.exports = __webpack_public_path__ + "img/card.1f52491f.png";